
import { AccordianHeaderLevel1, AccordianHeaderLevel2 } from 'Components/Accordian/AccordianHeader';
import { Row, Card, Col, Form } from "react-bootstrap";
import { http } from "Utils/http";
import { useEffect, useReducer, useState, useRef } from "react";
import Stack from 'react-bootstrap/Stack';
import { useLocation, useNavigate } from 'react-router-dom';
import 'react-phone-input-2/lib/style.css'
import { IconTextButton, TextButton } from 'Components/Button';
import { ERROR_MESSAGES, PSO_PROFILE_STATUSES } from "Utils/constants";
import { useDispatch } from "react-redux"
import { setGlobalSuccessStatus, setGlobalErrorStatus } from 'Components/StatusHandling';
import 'react-phone-input-2';
import { store } from 'Store';
import { GetOrgTextInputData, GetOrgDateInputData, GetPSOTextInputData, GetPSOCheckboxInputData } from 'Containers/Private/PSOProfile/PsoProfileFields';
import { UnfoldLessOutlined, UnfoldMoreOutlined } from '@mui/icons-material';
import { FormInputDisplay } from 'Components/Forms/FormInputDisplay.js';
import { SectionDataReducer } from 'Containers/Private/PSOProfile/SectionDataReducer';
import Accordion from 'react-bootstrap/Accordion';
import { PageInfo } from 'Components/PageInformation/PageInformation';
import PSOFormFields from '../PSOFormFields';
import { print } from 'Utils/utilityFunctions';
import { AddCheckboxNumber, AddRadioChk } from '../AddValues';
import { faL } from '@fortawesome/free-solid-svg-icons';

var focusError = null;
//var pageType = "EDIT"; //CARRY, EDIT, CREATE
var getDataURL = "/api/profile/addPsoProfile";

function ViewPSOProfile ({ pageType }) {
    //var mainErrorRef =  useRef(null);
    let location = useLocation();
    const navigate = useNavigate();
    var passedData = location.state;
    //console.log(passedData);
    const dispatch = useDispatch();

    //console.log(location);
    //console.log(window);
    //console.log(localStorage);
    //const state = store.getState();
    //console.log(state);

    var pageTitle = pageType == "CARRY" || pageType == "EDIT" ? "Edit PSO Profile" : "Create PSO Profile";
    if (pageType == "VIEW") {
        pageTitle = "View PSO Profile";
    }

    if (pageType == "CARRY") {
        getDataURL = '/api/profile/carryOverPsoProfile';
    }
    else if (pageType == "EDIT") {
        getDataURL = "/api/profile/editPsoProfile";
    }
    else if (pageType == "VIEW") {
        getDataURL = "/api/profile/viewPsoProfileDetail";
    }
    else {
        getDataURL = '/api/profile/addPsoProfile';
    }

    //var url = 

    // if(pageType=="CARRY"){
    //    url = '/api/profile/carryOverPsoProfile';
    // }



    // intialize as en empty array
    const refs = useRef([]); // or an {}
    var elIndex = {};
    // Make it empty at every render cycle as we will get the full list of it at the end of the render cycle
    refs.current = []; // or an {}
    elIndex = {};

    // since it is an array we need to method to add the refs
    const addToRefs = (el, index) => {
        //print(index);
        if (el && !refs.current.includes(el)) {
            //print(el);
            //print(refs.current);
            refs.current.push(el);
            elIndex[index] = ((refs.current).length) - 1;
        }
    };


    const ACTIONS = {
        CALL_API: 'call-api',
        SUCCESS: 'success',
        ERROR: 'error',
        SET_INITIAL_DATA: 'set-data',
        ADD_QUESTION: 'add-question',
        ADD_ANSWER: 'add-answer',

        UPDATE_QUESTION: 'update-question',
        UPDATE_ANSWER: 'update-answer',

        CLEAR_QUESTION_ANSWERS: 'clear-question-answers',

        TEXT_CHANGE: 'text-change',
        TEXT_SET_ERRORS: 'text-set-errors',
        TEXT_REMOVE_ERRORS: 'text-remove-errors',

        RADIO_CHANGE: 'radio-change',
        RADIO_SET_ERRORS: 'radio-set-errors',
        RADIO_REMOVE_ERRORS: 'radio-remove-errors',

        SELECT_CHANGE: 'select-change',
        SELECT_SET_ERRORS: 'select-set-errors',
        SELECT_REMOVE_ERRORS: 'select-remove-errors',

        SET_INITIAL_CHECK_DATA: 'set-check-data',
        CHECK_CHANGE: 'check-change',
        CHECK_SET_ERRORS: 'check-set-errors',
        CHECK_REMOVE_ERRORS: 'check-remove-errors',

        DATE_CHANGE: 'date-change',
        DATE_SET_ERRORS: 'date-set-errors',
        DATE_REMOVE_ERRORS: 'date-remove-errors',

        PHONE_CHANGE: 'phone-change',
        PHONE_SET_ERRORS: 'phone-set-errors',
        PHONE_REMOVE_ERRORS: 'phone-remove-errors'
    };

    const FORM_SECTIONS = {
        PSOChars: "psoCharacteristics",
        PartiProv: "participatingProviders",
        PtSafetyWorkProd: "patientSafetyWorkProduct",
        ProvProf: "providerProfile",
        AllProvTypes: "allProviderTypes",
        HospitalsOnly: "hosiptalsOnly"
    }

    const FORM_SECTIONS_REV = {
        "psoCharacteristics": "PSOChars",
        "participatingProviders": "PartiProv",
        "patientSafetyWorkProduct": "PtSafetyWorkProd",
        "providerProfile": "ProvProf",
        "allProviderTypes": "AllProvTypes",
        "hosiptalsOnly": "HospitalsOnly"
    }

    var [orgPsoId, orgPsoIdInputDispatch] = GetOrgTextInputData('psoId', '', '', 'view');
    var [orgPsoStatus, orgPsoStatusInputDispatch] = GetOrgTextInputData('psoStatus', '', '', 'view');
    var [orgListingDate, orgListingDateInputDispatch] = GetOrgDateInputData('listingDate', '', '', 'view');
    var [profileReportYear, profileReportYearInputDispatch] = GetPSOTextInputData('reportYear', '', '', 'view');
    var [userAnsState, setUserAnsState] = useState(null);

    const FORM_SECTION_NOTES = {
        PSOChars: (
            <p className="mb-1">
                The Patient Safety and Quality Improvement Final Rule defines a <b>component organization</b> and a <b>component PSO</b> as follows:
                <ul className="mt-3">
                    <li>A <b>component organization</b> is a unit or division of a legal entity or an entity that is owned, managed, or controlled by one or more legally separate parent organizations.</li>
                    <li>A <b>component PSO</b> is a PSO listed by the Secretary that is a component organization.</li>
                </ul>
                A component PSO may be a <b>separate legal entity</b> from its parent organization(s).
            </p>
        ),
        PSOCharsPt2: (
            <p className="mb-1">
                The Patient Safety and Quality Improvement Rule outlines eight specific activities as <b>patient safety activities</b>. These activities include:
                <ul className="mt-3">
                    <li>Efforts to improve patient safety and the quality of healthcare delivery</li>
                    <li>The collection and analysis of patient safety work product</li>
                    <li>The development and dissemination of information with respect to improving patient safety</li>
                    <li>The utilization of patient safety work product for the purposes of encouraging a culture of safety and providing feedback and assistance to effectively minimize patient risk</li>
                    <li>The maintenance of procedures to preserve confidentiality with respect to patient safety work product</li>
                    <li>The provision of appropriate security measures with respect to patient safety work product</li>
                    <li>The utilization of qualified staff</li>
                    <li>Activities related to the operation of a patient safety evaluation system and to the provision of feedback to participants in a patient safety evaluation system</li>
                </ul>
                In carrying out <b>patient safety activities</b>, PSOs are involved in efforts to improve the quality of healthcare delivery.
            </p>
        ),
        PartiProv: (
            <p className="mb-1">
                The term "provider" has a specific definition in the Patient Safety and Quality Improvement Rule at section 3.20.  The following categories - "individual" and "institutional" - apply to two types of providers included within this definition.  Use these categories for the purpose of answering question {profileReportYear.value>=2025 ? 7 : 6}:

                <br></br><br></br>
                <b>Individual providers</b> include offices of practitioners licensed or otherwise authorized under state law to provide health care services (e.g., doctor, nurse, dentist, psychologist, psychotherapist, etc.) with <u>five or fewer</u> such practitioners.

                <br></br><br></br>
                <b>Institutional providers</b> include all other types of providers licensed or otherwise authorized under state law to provide health care services (such as ambulance services, behavioral health services, hospitals, home health care, pharmacy, skilled nursing facility, urgent care, etc.), including offices with <u>six or more</u> practitioners.

                <br></br><br></br>
                <b>Count individual facilities under a health system or management contract as separate institutional providers.</b>
            </p>
        ),
        PtSafetyWorkProd: (
            <p className="mb-1">

            </p>
        ),
        ProvProf: (
            <p className="mb-1">
                The Provider Profile requests additional information about the providers with which the PSO works.
            </p>
        ),
        AllProvTypes: (
            <p className="mb-1">

            </p>
        ),
        HospitalsOnly: (
            <p className="mb-1">
                Questions 3, 4, and 5 below apply only to hospitals (of any type) that worked with your PSO in the previous calendar year. This includes critical access hospitals, general (acute care) hospitals, long term acute care hospitals, psychiatric hospitals, rehabilitation hospitals, specialty hospitals, and any other types of hospitals.
            </p>
        )
    }

    const FORM_SECTIONS_VISIBILITY = {
        PSOChars: true,
        PartiProv: true,
        PtSafetyWorkProd: true,
        ProvProf: true,
        AllProvTypes: true,
        HospitalsOnly: true
    }




    const [formSectionVisibility, setFormSectionVisibility] = useState(FORM_SECTIONS_VISIBILITY);
    const [profileId, setProfileId] = useState((pageType == "EDIT" || pageType == "VIEW") && passedData != null ? passedData.state.profileId : null);
    const [psoppcAdmin, setPsoppcAdmin] = useState((pageType == "EDIT") && passedData != null ? passedData.state.psoppcAdmin : null);
    //console.log(psoppcAdmin);
    const [firstError, setFirstError] = useState(null);

    var [profileAnswers, setProfileAnswers] = useState(null);
    var [profileFieldErrors, setProfileFieldErrors] = useState(null);
    var [globalErrorMessageList, setGlobalErrorMessageList] = useState([]);







    var [psoProfileSection, psoProfileSectionInputDispatch] = useReducer(SectionDataReducer, '');
    var [providerDetailsSection, providerDetailsSectionInputDispatch] = useReducer(SectionDataReducer, '');




    //console.log(formAnsweredSectionCount);
    //console.log(psoProfileSection);
    //console.log(providerDetailsSection);

    var [isLoading, setIsLoading] = useState(true);
    var [isLoadingSubmit, setIsLoadingSubmit] = useState(false);
    var [isValuesLoading, setIsValuesLoading] = useState(pageType == "CREATE" ? false : true);

    var [showProvSection, setShowProvSection] = useState(true); //TODO



    var [confirmSubmit, confirmSubmitInputDispatch] = GetPSOCheckboxInputData('confirmSubmit', '', '', 'create');

    var [orgId, setOrgId] = useState((pageType == "EDIT" || pageType == "VIEW") && passedData != null ? passedData.state.orgId : -1);

    const state = store.getState().errorInfo;

    const submitBtnRef = useRef(null);
    const saveBtnRef = useRef(null);


    function getCheckedValueBoxes (answers) {
        var boxes = {};
        /*
            checkedBoxes == null || (checkedBoxes.indexOf('C001') < 0  && checkedBoxes.indexOf('C002') < 0  && checkedBoxes.indexOf('C183') < 0 
                && checkedBoxes.indexOf('C214') < 0  && checkedBoxes.indexOf('C215') < 0  && checkedBoxes.indexOf('C216') < 0 )
        */
        answers.map(function (value, index) {
            ////console.log(index);
            //console.log(value);
            if (value.checked == true) {
                //console.log(value['value']);
                //console.log(value['answerCode']);
                boxes[value.answerCode] = value['value'];
            }
            return;
        })

        //console.log(boxes);
        return Object.keys(boxes).length > 0 ? boxes : {};
    }

    const isAnyAnswered = (answers) => {
        var answered = {};
        //console.log(answers);
        answers.map(function (value, index) {
            ////console.log(index);
            //console.log(value);
            if (value != null && value != "") {

                //console.log(value['value']);
                //console.log(value['answerCode']);
                answered[value.answerCode] = value['value'];
            }
            return;
        })

        //console.log(answered);
        return Object.keys(answered).length > 0 ? true : false;
    }

    function isQuestionVisible (question) {
        if (pageType == "VIEW") {
            //if(question.questionCode=="pso27" && question.value=="" || question.value==null){
            //    return false;
            //}
            //console.log(getCheckedValueBoxes(question.answers));

            if ((question.typeCode == "CHECKBOX_NUMBER" || question.typeCode == "CHECKBOX" || question.typeCode == "RADIO")) {
                if (Object.keys(getCheckedValueBoxes(question.answers)).length === 0) {

                    return false;
                }
            }
            if ((question.typeCode == "TEXT" || question.typeCode == "DATE" || question.typeCode == "NUMBER" || question.typeCode == "NUMBER_NP" || question.typeCode == "INDT_NUMBER")) {
                if (question.hasOwnProperty("answers") == true || question.answers.length == 0) {
                    if (question.value == null || question.value == "") {
                        //console.log(question);
                        return false;
                    }
                }
                else if (question.hasOwnProperty("answers") == true || question.answers.length > 0) {
                    var a = isAnyAnswered(question.answers);
                    return a;
                }

            }
        }
        return true;
    }

    const isSectionEmpty = (section, subSection) => {
        var count = 0;
        if (section != null && subSection != null) {
            var s = section.questions[subSection];
            //console.log(s);
            for (const [key, question] of Object.entries(s)) {
                var x = isQuestionVisible(question);
                if (x == true) {
                    count = count + 1;
                }
            }
        }
        return count == 0;

    }

    const isSectionVisible = (section, subSection) => {
        if (pageType == "VIEW" && isSectionEmpty(section, subSection) == true) {
            return false;
        }
        else {
            return true;
        }
    }

    //console.log(location);
    //console.log(window);
    //console.log(localStorage);
    //const state = store.getState();
    //console.log(state);

    useEffect(() => {
        //console.log(showProvSection);
        //console.log(providerDetailsSection);
        if (pageType != "VIEW") {
            if (isLoading == false && showProvSection == false && isValuesLoading == false && providerDetailsSection != null && providerDetailsSection.hasOwnProperty("questions")) {
                var d = providerDetailsSection.questions;
                //console.log(providerDetailsSection);
                for (const [subsection, questions] of Object.entries(d)) {
                    //console.log(questions);
                    //console.log(subsection);
                    for (const [key, question] of Object.entries(questions)) {
                        //console.log(question);
                        providerDetailsSectionInputDispatch({
                            type: ACTIONS.CLEAR_QUESTION_ANSWERS,
                            questionId: question.id,
                            questionCode: question.questionCode,
                            subSection: subsection,
                            pageType: pageType
                            //isInvalid: false,
                            //errors:[]
                        });
                    }
                }
            }
        }

    }, [showProvSection]);

    useEffect(() => {
        if (isLoading == false && isValuesLoading == false && pageType != "VIEW") {
            var d = providerDetailsSection.questions;
            //console.log(providerDetailsSection);
            //console.log(psoProfileSection);
            //console.log(formSectionVisibility);

            if (formSectionVisibility.PSOChars == false) {
                var s = psoProfileSection.questions.psoCharacteristics;
                for (const [key, question] of Object.entries(s)) {
                    if (s.hasOwnProperty(key)) {
                        psoProfileSectionInputDispatch({
                            type: ACTIONS.CLEAR_QUESTION_ANSWERS,
                            questionId: question.id,
                            questionCode: question.questionCode,
                            subSection: "psoCharacteristics",
                            pageType: pageType
                        });
                    }
                }
            }
            if (formSectionVisibility.PartiProv == false) {
                var s = psoProfileSection.questions.participatingProviders;
                for (const [key, question] of Object.entries(s)) {
                    if (s.hasOwnProperty(key)) {
                        psoProfileSectionInputDispatch({
                            type: ACTIONS.CLEAR_QUESTION_ANSWERS,
                            questionId: question.id,
                            questionCode: question.questionCode,
                            subSection: "participatingProviders",
                            pageType: pageType
                        });
                    }
                }
            }
            if (formSectionVisibility.PtSafetyWorkProd == false) {
                var s = psoProfileSection.questions.patientSafetyWorkProduct;
                for (const [key, question] of Object.entries(s)) {
                    if (s.hasOwnProperty(key)) {
                        psoProfileSectionInputDispatch({
                            type: ACTIONS.CLEAR_QUESTION_ANSWERS,
                            questionId: question.id,
                            questionCode: question.questionCode,
                            subSection: "patientSafetyWorkProduct",
                            pageType: pageType
                        });
                    }
                }
            }

            if (providerDetailsSection != null && providerDetailsSection.hasOwnProperty("questions")) {
                if (formSectionVisibility.ProvProf == false) {
                    var s = providerDetailsSection.questions.providerProfile;
                    for (const [key, question] of Object.entries(s)) {
                        if (s.hasOwnProperty(key)) {
                            providerDetailsSectionInputDispatch({
                                type: ACTIONS.CLEAR_QUESTION_ANSWERS,
                                questionId: question.id,
                                questionCode: question.questionCode,
                                subSection: "providerProfile",
                                pageType: pageType
                            });
                        }
                    }
                }
                if (formSectionVisibility.AllProvTypes == false) {
                    var s = providerDetailsSection.questions.allProviderTypes;
                    for (const [key, question] of Object.entries(s)) {
                        if (s.hasOwnProperty(key)) {
                            providerDetailsSectionInputDispatch({
                                type: ACTIONS.CLEAR_QUESTION_ANSWERS,
                                questionId: question.id,
                                questionCode: question.questionCode,
                                subSection: "allProviderTypes",
                                pageType: pageType
                            });
                        }
                    }
                }
                if (formSectionVisibility.HospitalsOnly == false) {
                    var s = providerDetailsSection.questions.hosiptalsOnly;
                    for (const [key, question] of Object.entries(s)) {
                        if (s.hasOwnProperty(key)) {
                            providerDetailsSectionInputDispatch({
                                type: ACTIONS.CLEAR_QUESTION_ANSWERS,
                                questionId: question.id,
                                questionCode: question.questionCode,
                                subSection: "hosiptalsOnly",
                                pageType: pageType
                            });
                        }
                    }
                }
            }
        }


    }, [formSectionVisibility])

    useEffect(() => {
        if (focusError != null && state.popup.visible == false && state.status.code == 0 && submitBtnRef.current != null && saveBtnRef.current != null) {
            submitBtnRef.current.blur();
            saveBtnRef.current.blur();
            //console.log(focusError);
            //console.log(firstError);
            //console.log(elIndex[firstError]);
            //console.log(refs.current[elIndex[firstError]]);
            //(refs.current[elIndex[firstError]])?.scrollIntoView();  
            (refs.current[elIndex[firstError]])?.focus();
            //refs.current = [];
            setFirstError(null);
            focusError = null;
        }


    }, [firstError, state, submitBtnRef, saveBtnRef, refs.current])

    const getDateFormat = (value) => {
        if (value != null) {
            var split = value.split('/');
            if (split.length == 3) {
                return split[2] + '-' + split[0] + '-' + split[1];
            }
            return value;
        }
        else {
            return null;
        }

    }

    const setInitialData = (dispatch, value) => {
        dispatch({
            type: ACTIONS.SET_INITIAL_DATA,
            value: value,
            pageType: pageType
        })
    }

    const setInitialSectionData = (dispatch, sectionName) => {
        dispatch({
            type: ACTIONS.SET_INITIAL_DATA,
            sectionName: sectionName,
            pageType: pageType
        })
    }

    const addQuestion = (dispatch, data, subSection, value, checked, visible, refIndex) => {


        //console.log(data.questionCode + "---" + data.typeCode);
        dispatch({
            type: ACTIONS.ADD_QUESTION,
            subSection: subSection,
            questionId: data.id,
            questionOrderNo: data.orderNumber,
            questionCode: data.questionCode.toLowerCase(),
            questionReportYear: data.reportYear,

            questionDispNo: data.questionDisplayNo,
            questionDesc: data.description,
            questionSubText: data.subText,

            questionType: data.typeCode,
            questionTopicCode: data.topicCode,

            adminOnly: data.adminOnly,
            questionRequired: data.required,

            questionMaxLength: data.maxLength,
            questionMaxValue: data.maxValue,
            answers: [

            ],
            value: value,
            checked: checked,
            visible: true,
            disabled: false,

            isInvalid: false,
            errors: [],
            isValid: false,
            pageType: pageType
        });

    }

    const addAnswer = (dispatch, question, data, subSection, value, checked, disabled, visible) => {
        dispatch({
            type: ACTIONS.ADD_ANSWER,
            questionId: question.id,
            questionCode: question.questionCode.toLowerCase(),
            subSection: subSection,
            pageType: pageType,
            newAnswer:
            {
                id: data.id,
                answerCode: data.answerCode,
                description: data.description,
                maxLength: data.maxLength,
                reportYear: data.reportYear,
                maxValue: data.maxValue,
                value: value,
                checked: checked,
                disabled: false,
                visible: true,

                isInvalid: false,
                errors: [],
                isValid: false
            }
        });
    }

    function addValue (section, dispatch, subSection, value, key, answers) {
        //console.log(value.length<1);
        var questions = section.questions[subSection];
        var baseKey = key.replace(/providechk|txt|chk|number/gi, "");
        //console.log(value);
        //console.log(questions);

        if (Array.isArray(value)) {
            for (var x = 0; x < value.length; x++) {
                //console.log(value[x]);

                if (value[x] == "C012" || value[x] == "C199") {

                    //if(questions[baseKey].typeCode=="CHECKBOX_NUMBER"){
                    AddCheckboxNumber(section, dispatch, subSection, value[x], key, answers, questions, baseKey, pageType);
                    //}
                    /*else{
                        if(answers.hasOwnProperty(key+"txt")){
                            dispatch({
                                type: ACTIONS.UPDATE_ANSWER,
                                //questionId: question.id,
                                questionCode: key,//question.questionCode,
                                subSection: subSection,
                                answerCode: value[x],
                                checked: true,
                                value: answers[key+"txt"],
                                //visible: true,//!answerDisplayConditions(answerCode,e)
                                isInvalid: false,
                                errors:[]
                            }); 
                        }
                    }*/


                }
                else {
                    if (questions[baseKey].typeCode == "CHECKBOX_NUMBER") {
                        AddCheckboxNumber(section, dispatch, subSection, value[x], key, answers, questions, baseKey, pageType);
                    }
                    else if (questions[baseKey].typeCode == "RADIO" || questions[baseKey].typeCode == "CHECKBOX") {
                        AddRadioChk(section, dispatch, subSection, value[x], key, answers, questions, baseKey, pageType);
                    }

                    /*if(answers.hasOwnProperty(baseKey+"txt")){
                        dispatch({
                            type: ACTIONS.UPDATE_ANSWER,
                            //questionId: question.id,
                            questionCode: key,//question.questionCode,
                            subSection: subSection,
                            answerCode: value[x],
                            checked: true,
                            value: answers[baseKey+"txt"],
                            //visible: true,//!answerDisplayConditions(answerCode,e)
                            isInvalid: false,
                            errors:[]
                        }); 
                    }
                    if(answers.hasOwnProperty(baseKey+value[x]+"number")){
                        dispatch({
                            type: ACTIONS.UPDATE_ANSWER,
                            //questionId: question.id,
                            questionCode: key,//question.questionCode,
                            subSection: subSection,
                            answerCode: value[x],
                            checked: true,
                            value: answers.hasOwnProperty(baseKey+value[x]+"number") == true ? answers[baseKey+value[x]+"number"] : "", //answers[key+"txt"],
                            //visible: true,//!answerDisplayConditions(answerCode,e)
                            isInvalid: false,
                            errors:[]
                        }); 
                    }
                
            }*/
                    else {
                        dispatch({
                            type: ACTIONS.UPDATE_ANSWER,
                            //questionId: question.id,
                            questionCode: baseKey,//question.questionCode,
                            subSection: subSection,
                            answerCode: value[x],
                            checked: true,
                            //visible: true,
                            //value: e.target.checked,
                            //visible: true,//!answerDisplayConditions(answerCode,e)
                            isInvalid: false,
                            errors: [],
                            pageType: pageType
                        });
                    }

                }



            }

        }
        else {
            //console.log(value);
            //console.log(key);

            if (!key.includes("txt") && !key.includes("chk")) {
                //console.log("notxt or chk");
                //console.log("else");
                //console.log(value);
                //console.log(key);
                //console.log(questions[baseKey]);

                if (questions[baseKey].typeCode == "CHECKBOX_NUMBER") {
                    AddCheckboxNumber(section, dispatch, subSection, value, key, answers, questions, baseKey, pageType);
                }
                if (questions[baseKey].typeCode == "RADIO" || questions[baseKey].typeCode == "CHECKBOX") {
                    if (value == "C012" || value == "C199") {
                        AddCheckboxNumber(section, dispatch, subSection, value, key, answers, questions, baseKey, pageType);
                    }
                    else {
                        //console.log("ADDRADIO")
                        AddRadioChk(section, dispatch, subSection, value, key, answers, questions, baseKey, pageType);
                    }

                }
                //console.log(questions[key]);
                if (questions[baseKey].typeCode == "NUMBER") {
                    if (baseKey == "pso30" || baseKey == "pso31") {
                        //console.log("PSO30 - " + value + " " + baseKey);

                        dispatch({
                            type: ACTIONS.UPDATE_QUESTION,
                            questionId: questions[baseKey].id,
                            questionCode: questions[baseKey].questionCode,
                            subSection: "participatingProviders",
                            value: answers[baseKey],
                            //visible: true,
                            pageType: pageType
                        });
                    }
                    else if (baseKey == "pso30" || baseKey == "pso31") {
                        //console.log("PSO30 - " + value + " " + baseKey);

                        dispatch({
                            type: ACTIONS.UPDATE_QUESTION,
                            questionId: questions[baseKey].id,
                            questionCode: questions[baseKey].questionCode,
                            subSection: "participatingProviders",
                            value: answers[baseKey],
                            // visible: true,
                            pageType: pageType
                        });
                    }


                    if (answers.hasOwnProperty(baseKey + "providechk")) {
                        //var qs = q[key];
                        //console.log(questions[key]);
                        //console.log(answers[key+"providechk"]);
                        //console.log("PSO30PROVCHK - " + value);
                        /*if(q[key].typeCode=="NUMBER"){
                            dispatch({
                                type: ACTIONS.UPDATE_QUESTION,
                                questionId: q[key].id,
                                questionCode: q[key].questionCode,
                                subSection: subSection,
                                //value: answers[key+"providechk"] == -1 ? -1 : 0,
                                checked: answers[key+"providechk"] == -1 ? true : false,
                                isInvalid: false,
                                errors:[]
                            }); 
                        }*/
                    }
                    //console.log(value);
                    //console.log(answers[key] + " " + key);


                }
                else {

                }
                if (questions[baseKey].typeCode == "NUMBER_NP") {
                    //console.log(questions[key]);
                    dispatch({
                        type: ACTIONS.UPDATE_QUESTION,
                        questionId: questions[baseKey].id,
                        questionCode: questions[baseKey].questionCode,
                        subSection: subSection,
                        value: answers[baseKey],
                        pageType: pageType,
                        //visible: true
                        //visible: pageType=="VIEW" && (answers[key]==null || answers[key]=="") ? false : true
                    });

                    //console.log(value);
                    //console.log(answers[key] + " " + key);


                }
                if (questions[baseKey].typeCode == "INDT_NUMBER") {
                    //console.log(questions[key]);
                    dispatch({
                        type: ACTIONS.UPDATE_QUESTION,
                        questionId: questions[baseKey].id,
                        questionCode: questions[baseKey].questionCode,
                        subSection: subSection,
                        value: answers[baseKey] != -1 ? answers[baseKey] : "N/A",
                        pageType: pageType,
                        //visible: true
                    });

                    //console.log(value);
                    //console.log(answers[key] + " " + key);


                }



            }
            else {
                if (answers.hasOwnProperty(key)) {

                    var base = key.replace("providechk", "");
                    //var qs = q[key];
                    //console.log(questions[base]);
                    //console.log(answers[key]);
                    //console.log(questions[baseKey]);
                    //console.log(value);

                    if (questions[baseKey].typeCode == "NUMBER") {
                        dispatch({
                            type: ACTIONS.UPDATE_QUESTION,
                            questionId: questions[base].id,
                            questionCode: questions[base].questionCode,
                            subSection: subSection,
                            value: answers[key] == -1 ? -1 : 0,
                            checked: answers[key] == -1 ? true : false,
                            isInvalid: false,
                            errors: [],
                            pageType: pageType,
                            //visible: true
                        });
                    }

                    if (value[x] == "C012" || value[x] == "C199") {
                        //console.log(questions);
                        /*if(q[baseKey].typeCode=="CHECKBOX_NUMBER"){
                            if(answers.hasOwnProperty(baseKey+"txt") || answers.hasOwnProperty(baseKey+answers[key]+"number")){
                                //console.log(key+value[x]+"number");
                                //console.log(answers[key+"txt"])
                                dispatch({
                                    type: ACTIONS.UPDATE_ANSWER,
                                    //questionId: question.id,
                                    questionCode: key,//question.questionCode,
                                    subSection: subSection,
                                    answerCode: value[x],
                                    checked: true,
                                    value: answers[key+"txt"],
                                    //visible: true,//!answerDisplayConditions(answerCode,e)
                                    isInvalid: false,
                                    errors:[]
                                }); 
                            }
                        }*/
                    }
                    else {
                        if (answers.hasOwnProperty(baseKey + "txt")) {
                            //console.log(answers[baseKey + "txt"])
                            dispatch({
                                type: ACTIONS.UPDATE_ANSWER,
                                //questionId: question.id,
                                questionCode: baseKey,//question.questionCode,
                                subSection: subSection,
                                answerCode: value[x],
                                checked: true,
                                value: answers[baseKey + "txt"],
                                //visible: true,//!answerDisplayConditions(answerCode,e)
                                isInvalid: false,
                                errors: [],
                                pageType: pageType,
                                //visible: true
                            });
                        }
                    }
                }

                else {
                    //console.log("UP{DATEAMNSWRR");
                    dispatch({
                        type: ACTIONS.UPDATE_ANSWER,
                        //questionId: question.id,
                        questionCode: baseKey,//question.questionCode,
                        subSection: subSection,
                        answerCode: value[x],
                        checked: true,

                        //value: e.target.checked,
                        //visible: true,//!answerDisplayConditions(answerCode,e)
                        isInvalid: false,
                        errors: [],
                        pageType: pageType,
                        //visible: true
                    });
                }

            }
        }

    }
    function addExistingVals (answers) {

        //console.log(psoProfileSection);
        //console.log(providerDetailsSection);


        //psoProfileSection,psoProfileSectionInputDispatch
        //providerDetailsSection,providerDetailsSectionInputDispatch

        for (var [key, value] of Object.entries(answers)) {
            //console.log(key + ": " + value);
            //console.log((psoProfileSection).hasOwnProperty("questions"));
            //console.log((psoProfileSection.questions));
            var baseKey = key.replace(/providechk|txt|chk/gi, "");
            //console.log(baseKey);

            if ((psoProfileSection).hasOwnProperty("questions") == true) {
                if ((psoProfileSection.questions[FORM_SECTIONS.PSOChars]).hasOwnProperty(baseKey) == true) {
                    //console.log(FORM_SECTIONS.PSOChars);
                    addValue(psoProfileSection, psoProfileSectionInputDispatch, FORM_SECTIONS.PSOChars, value, key, answers);
                }
                else if ((psoProfileSection.questions[FORM_SECTIONS.PartiProv]).hasOwnProperty(baseKey) == true) {
                    //console.log(FORM_SECTIONS.PartiProv);
                    addValue(psoProfileSection, psoProfileSectionInputDispatch, FORM_SECTIONS.PartiProv, value, key, answers);
                }
                else if ((psoProfileSection.questions[FORM_SECTIONS.PtSafetyWorkProd]).hasOwnProperty(baseKey) == true) {
                    //console.log(FORM_SECTIONS.PtSafetyWorkProd);
                    addValue(psoProfileSection, psoProfileSectionInputDispatch, FORM_SECTIONS.PtSafetyWorkProd, value, key, answers);
                }

            }

            if (profileReportYear.value > 2019) {
                if ((providerDetailsSection).hasOwnProperty("questions") == true) {
                    if ((providerDetailsSection.questions[FORM_SECTIONS.ProvProf]).hasOwnProperty(baseKey) == true) {
                        //console.log(FORM_SECTIONS.ProvProf);

                        addValue(providerDetailsSection, providerDetailsSectionInputDispatch, FORM_SECTIONS.ProvProf, value, key, answers);
                    }
                    else if ((providerDetailsSection.questions[FORM_SECTIONS.AllProvTypes]).hasOwnProperty(baseKey) == true) {
                        //console.log(FORM_SECTIONS.AllProvTypes);

                        addValue(providerDetailsSection, providerDetailsSectionInputDispatch, FORM_SECTIONS.AllProvTypes, value, key, answers);
                    }
                    else if ((providerDetailsSection.questions[FORM_SECTIONS.HospitalsOnly]).hasOwnProperty(baseKey) == true) {
                        //console.log(FORM_SECTIONS.HospitalsOnly);

                        addValue(providerDetailsSection, providerDetailsSectionInputDispatch, FORM_SECTIONS.HospitalsOnly, value, key, answers);
                    }
                }
            }

        }


        setIsValuesLoading(false);


    }

    const loadUserData = async () => {
        setIsLoading(true);
        var url = getDataURL;//'/api/profile/carryOverPsoProfile';//"/api/profile/editPsoProfile";//'/api/profile/addPsoProfile';
        var data = null;

        //if(pageType=="CARRY"){
        //    url = '/api/profile/carryOverPsoProfile';
        //}

        //console.log(pageType);

        if (pageType == "EDIT" || pageType == "VIEW") {
            data = {
                profileId: profileId,
                //selectedOrganizationId: orgId
            }
        }
        const loginState = store.getState().loginInfo;
        const res = http.post(url, data, {
            timeout: 65000, // Set a timeout of 5 seconds
            headers: {
                "Authorization": "Bearer " + loginState.token
            }
        }).then((response) => {
            if (response != null) {
                var statusCode = response.status;
                if (statusCode != 1 && (statusCode != -1 && pageType != "EDIT")) {
                    setGlobalErrorStatus({
                        dispatch: dispatch,
                        popupData: {
                            visible: true,
                            title: ERROR_MESSAGES.GENERAL_ERROR.title,
                            msg: ERROR_MESSAGES.GENERAL_ERROR.message,
                            showContactHelp: true
                        },
                        redirect: {
                            redirect: false,
                            redirectFirst: false,
                            path: "",
                            data: {}
                        }
                    });
                }
                else {
                    //console.log("test");
                    //console.log(response);
                    if (pageType == "CARRY" || pageType == "EDIT" || pageType == "VIEW") {
                        setOrgId(response.data.profileDetail.organizationId);
                        setProfileAnswers(response.data.profileDetail.answers);
                        if (pageType == "VIEW") {
                            setInitialData(orgPsoIdInputDispatch, response.data.psoId);
                            setUserAnsState(response.data.userAnsState);
                        }
                        else {
                            setInitialData(orgPsoIdInputDispatch, response.data.psoId);
                        }
                        setInitialData(orgListingDateInputDispatch, getDateFormat(response.data.orgListingDate));

                        if (pageType == "CARRY") {
                            setInitialData(profileReportYearInputDispatch, response.data.reportingYear);
                        }
                        else {
                            setInitialData(profileReportYearInputDispatch, response.data.profileDetail.reportYear);
                        }


                        var statId = response.data.profileDetail.profileStatusId;
                        if (statId != null) {
                            setInitialData(orgPsoStatusInputDispatch, PSO_PROFILE_STATUSES[statId]);
                        }

                        if (pageType == "EDIT") {
                            setProfileFieldErrors(response.fieldErrors);
                            setGlobalErrorMessageList(response.globalErrorMessageList);
                        }
                    }
                    else {
                        setOrgId(response.data.orgId);
                        setInitialData(orgPsoIdInputDispatch, response.data.psoId);
                        setInitialData(orgListingDateInputDispatch, getDateFormat(response.data.orgListingDate));
                        setInitialData(profileReportYearInputDispatch, response.data.reportingYear);
                    }

                    setInitialSectionData(psoProfileSectionInputDispatch, 'PSOProfile', 8);
                    setInitialSectionData(providerDetailsSectionInputDispatch, 'ProviderDetails', 5);

                    var isViewPage = pageType == "VIEW" ? true : false;


                    var psoProfileQuestions = response.data.psoProfileQuestions;
                    var psoProfileAnswers = response.data.psoProfileAnswers;

                    var section = FORM_SECTIONS.PSOChars;
                    if (psoProfileQuestions != null) {
                        var secDisp = psoProfileSectionInputDispatch;
                        for (var x = 0; x < psoProfileQuestions.length; x++) {
                            var questionCode = psoProfileQuestions[x]["questionCode"].toLowerCase() + psoProfileQuestions[x]["id"];




                            //console.log(response.data.reportingYear);

                            if (response.data.reportingYear <= 2019) {
                                if (psoProfileQuestions[x].questionDisplayNo == 8) {
                                    section = FORM_SECTIONS.PartiProv;
                                }
                                if (psoProfileQuestions[x].questionDisplayNo == 11) {
                                    section = FORM_SECTIONS.PtSafetyWorkProd;
                                }
                                /*if(psoProfileQuestions[x].questionDisplayNo==9){
                                    secDisp = providerDetailsSectionInputDispatch;
                                    section = FORM_SECTIONS.ProvProf;
                                }
                                if(psoProfileQuestions[x].questionDisplayNo==10){
                                    secDisp = providerDetailsSectionInputDispatch;
                                    section = FORM_SECTIONS.AllProvTypes;
                                }
                                if(psoProfileQuestions[x].questionDisplayNo==13){
                                    secDisp = providerDetailsSectionInputDispatch;
                                    section = FORM_SECTIONS.HospitalsOnly;
                                }*/


                            }
                            else if (response.data.reportingYear >= 2025) {
                                if (psoProfileQuestions[x].questionDisplayNo == 7) {
                                    section = FORM_SECTIONS.PartiProv;
                                }
                                if (psoProfileQuestions[x].questionDisplayNo == 8) {
                                    section = FORM_SECTIONS.PtSafetyWorkProd;
                                }
                                /*if(psoProfileQuestions[x].questionDisplayNo==9){
                                    secDisp = providerDetailsSectionInputDispatch;
                                    section = FORM_SECTIONS.ProvProf;
                                }
                                if(psoProfileQuestions[x].questionDisplayNo==10){
                                    secDisp = providerDetailsSectionInputDispatch;
                                    section = FORM_SECTIONS.AllProvTypes;
                                }
                                if(psoProfileQuestions[x].questionDisplayNo==13){
                                    secDisp = providerDetailsSectionInputDispatch;
                                    section = FORM_SECTIONS.HospitalsOnly;
                                }*/


                            }
                            else {
                                if (psoProfileQuestions[x].questionDisplayNo == 6) {
                                    section = FORM_SECTIONS.PartiProv;
                                }
                                if (psoProfileQuestions[x].questionDisplayNo == 7) {
                                    section = FORM_SECTIONS.PtSafetyWorkProd;
                                }
                            }

                            //console.log(psoProfileQuestions[x]);

                            addQuestion(secDisp, psoProfileQuestions[x], section, '', false, !isViewPage);

                            for (var y = 0; y < psoProfileAnswers[psoProfileQuestions[x]["questionCode"].toLowerCase()].length; y++) {
                                if (psoProfileQuestions[x].typeCode == "CHECKBOX_NUMBER" && ((psoProfileAnswers[psoProfileQuestions[x]["questionCode"].toLowerCase()][y]).answerCode == "C199" || (psoProfileAnswers[psoProfileQuestions[x]["questionCode"].toLowerCase()][y]).answerCode == "C012")) {
                                    addAnswer(secDisp, psoProfileQuestions[x], psoProfileAnswers[psoProfileQuestions[x]["questionCode"].toLowerCase()][y], section, { number: '', text: '' }, false, !isViewPage);
                                }
                                else {
                                    addAnswer(secDisp, psoProfileQuestions[x], psoProfileAnswers[psoProfileQuestions[x]["questionCode"].toLowerCase()][y], section, '', false, !isViewPage);
                                }
                            }
                        }
                    }



                    var psoProviderProfileQuestions = response.data.psoProviderProfileQuestions;
                    var psoProviderProfileAnswers = response.data.psoProviderProfileAnswers;

                    section = FORM_SECTIONS.ProvProf;

                    if (psoProviderProfileQuestions != null) {
                        for (var x = 0; x < psoProviderProfileQuestions.length; x++) {


                            //console.log(psoProviderProfileQuestions[x]);
                            var questionCode = psoProviderProfileQuestions[x]["questionCode"].toLowerCase() + psoProviderProfileQuestions[x]["id"];

                            if (psoProviderProfileQuestions[x].questionDisplayNo == 2) {
                                section = FORM_SECTIONS.AllProvTypes;
                            }
                            if (psoProviderProfileQuestions[x].questionDisplayNo == 3) {
                                section = FORM_SECTIONS.HospitalsOnly;
                            }

                            addQuestion(providerDetailsSectionInputDispatch, psoProviderProfileQuestions[x], section, '', false, !isViewPage);

                            for (var y = 0; y < psoProviderProfileAnswers[psoProviderProfileQuestions[x]["questionCode"].toLowerCase()].length; y++) {
                                if (psoProviderProfileQuestions[x].typeCode == "CHECKBOX_NUMBER" && ((psoProviderProfileAnswers[psoProviderProfileQuestions[x]["questionCode"].toLowerCase()][y]).answerCode == "C199" || (psoProviderProfileAnswers[psoProviderProfileQuestions[x]["questionCode"].toLowerCase()][y]).answerCode == "C012")) {
                                    addAnswer(providerDetailsSectionInputDispatch, psoProviderProfileQuestions[x], psoProviderProfileAnswers[psoProviderProfileQuestions[x]["questionCode"].toLowerCase()][y], section, { number: '', text: '' }, false, !isViewPage);
                                }
                                else {
                                    addAnswer(providerDetailsSectionInputDispatch, psoProviderProfileQuestions[x], psoProviderProfileAnswers[psoProviderProfileQuestions[x]["questionCode"].toLowerCase()][y], section, '', false, !isViewPage);
                                }
                            }
                        }
                    }

                }
                setIsLoading(false);
            }
            else {
                setGlobalErrorStatus({
                    dispatch: dispatch,
                    popupData: {
                        visible: true,
                        title: ERROR_MESSAGES.GENERAL_ERROR.title,
                        msg: ERROR_MESSAGES.GENERAL_ERROR.message,
                        showContactHelp: true
                    },
                    redirect: {
                        redirect: false,
                        redirectFirst: false,
                        path: "",
                        data: {}
                    }
                });
            }

            //return response;
        })/*.then((response) => {
                var statusCode = response.status;
                
                if(statusCode!=1 || response.globalErrorMessageList.length>0){
                    //console.log(response.globalErrorMessageList);
                    var d = response.fieldErrors;
                    //console.log(d);
                    
                    if(d.hasOwnProperty("confirmSubmit")){
                        var errorM = d["confirmSubmit"].errorMessages;
                        confirmSubmitInputDispatch({
                             type: 'check-set-errors',
                             errors: errorM
                        });
                    }

                    setGlobalErrorStatus({
                        dispatch: dispatch,
                        popupData: {
                            visible: true, 
                            title: ERROR_MESSAGES.GENERAL_ERROR.title, 
                            msg: response.globalErrorMessageList, 
                            showContactHelp: false 
                        },
                        redirect: {
                            redirect: false, 
                            redirectFirst: false,
                            path: "", 
                            data: {}
                        }
                    });

                    addQuestionErrors(d,psoProfileSection, psoProfileSectionInputDispatch);
                    addQuestionErrors(d,providerDetailsSection,providerDetailsSectionInputDispatch);
                }
        })*/.catch(function (error) {
            setGlobalErrorStatus({
                dispatch: dispatch,
                popupData: {
                    visible: true,
                    title: ERROR_MESSAGES.GENERAL_ERROR.title,
                    msg: ERROR_MESSAGES.GENERAL_ERROR.message,
                    showContactHelp: true
                },
                redirect: {
                    redirect: false,
                    redirectFirst: false,
                    path: "",
                    data: {}
                },
                error: error
            });
        });
        return res;
    };

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        loadUserData();
        //console.log(state);
    }, []);

    useEffect(() => {
        if (profileAnswers != null && isLoading == false) {
            setIsValuesLoading(true);
            addExistingVals(profileAnswers);
        }

    }, [profileAnswers, isLoading]);

    useEffect(() => {
        //console.log(profileFieldErrors);
        var d = profileFieldErrors;
        if (d != null && Object.keys(d).length > 0 && isLoading == false) {
            if (d.hasOwnProperty("confirmSubmit")) {
                var errorM = d["confirmSubmit"].errorMessages;
                confirmSubmitInputDispatch({
                    type: 'check-set-errors',
                    errors: errorM
                });
            }

            /*setGlobalErrorStatus({
                dispatch: dispatch,
                popupData: {
                    visible: true, 
                    title: ERROR_MESSAGES.GENERAL_ERROR.title, 
                    msg: "test",//response.globalErrorMessageList, 
                    showContactHelp: false 
                },
                redirect: {
                    redirect: false, 
                    redirectFirst: false,
                    path: "", 
                    data: {}
                }
            });*/

            addQuestionErrors(d, psoProfileSection, psoProfileSectionInputDispatch, false);
            addQuestionErrors(d, providerDetailsSection, providerDetailsSectionInputDispatch, false);

            setGlobalErrorStatus({
                dispatch: dispatch,
                popupData: {
                    visible: true,
                    title: ERROR_MESSAGES.GENERAL_ERROR.title,
                    msg: globalErrorMessageList,//response.globalErrorMessageList, 
                    showContactHelp: false
                },
                redirect: {
                    redirect: false,
                    redirectFirst: false,
                    path: "",
                    data: {}
                }
            });
        }

    }, [profileFieldErrors])

    const [backRedirect, setBackRedirect] = useState(passedData != null && passedData.hasOwnProperty("backRedirect") ? passedData.backRedirect : null);

    const [activeKeys, setActiveKeys] = useState(['PSO Details', 'Provider Details']);
    const [psoDetailsActive, setPsoDetailsActive] = useState([]);
    const [providerDetailsActive, setProviderDetailsActive] = useState([]);

    const onAccordionToggle = (e, key, section) => {
        //if(pageType=="VIEW" && isSectionEmpty(section,key)==false){
        var value = [];
        switch (section) {
            case "psoDetails":
                value = psoDetailsActive;
                break;
            case "providerDetails":
                value = providerDetailsActive;
                break;
            case "main":
                value = activeKeys;
                break;
        }

        //console.log(e.target.parentNode.className);
        var parentClasses = e.target.parentNode.className.split(" ");
        var isDisabled = parentClasses.includes("disabled");
        //console.log(parentClasses);


        var split = e.target.className.split(" ");
        if (split != null) {
            if (split.includes("collapsed") && isDisabled == false) {
                if (!(value).includes(key)) {
                    switch (section) {
                        case "psoDetails":
                            setPsoDetailsActive(value => [...value, key]);
                            break;
                        case "providerDetails":
                            setProviderDetailsActive(value => [...value, key]);
                            break;
                        case "main":
                            setActiveKeys(value => [...value, key]);
                            break;
                    }
                }
            }
            else {
                if (value.includes(key)) {
                    switch (section) {
                        case "psoDetails":
                            setPsoDetailsActive(value => (value.filter(k => k != key)));
                            break;
                        case "providerDetails":
                            setProviderDetailsActive(value => (value.filter(k => k != key)));
                            break;
                        case "main":
                            setActiveKeys(value => (value.filter(k => k != key)));
                            break;
                    }
                }
                else {

                }
            }
        }
        //}
        //else{

        //}

    }

    const onExpandAll = (e) => {
        setActiveKeys(['PSO Details', 'Provider Details']);
        var pso = [];
        var prov = [];

        if (pageType == "VIEW") {
            if (profileReportYear.value > 2019) {
                if (isSectionEmpty(providerDetailsSection, FORM_SECTIONS.ProvProf) == false) {
                    prov.push(FORM_SECTIONS.ProvProf);
                }
                if (isSectionEmpty(providerDetailsSection, FORM_SECTIONS.AllProvTypes) == false) {
                    prov.push(FORM_SECTIONS.AllProvTypes);
                }
                if (isSectionEmpty(providerDetailsSection, FORM_SECTIONS.HospitalsOnly) == false) {
                    prov.push(FORM_SECTIONS.HospitalsOnly);
                }
            }

            if (isSectionEmpty(psoProfileSection, FORM_SECTIONS.PSOChars) == false) {
                pso.push(FORM_SECTIONS.PSOChars);
            }
            if (isSectionEmpty(psoProfileSection, FORM_SECTIONS.PartiProv) == false) {
                pso.push(FORM_SECTIONS.PartiProv);
            }
            if (isSectionEmpty(psoProfileSection, FORM_SECTIONS.PtSafetyWorkProd) == false) {
                pso.push(FORM_SECTIONS.PtSafetyWorkProd);
            }
            setPsoDetailsActive(pso);
            setProviderDetailsActive(prov);
        }
        else {
            setPsoDetailsActive([FORM_SECTIONS.PSOChars, FORM_SECTIONS.PartiProv, FORM_SECTIONS.PtSafetyWorkProd]);
            setProviderDetailsActive([FORM_SECTIONS.ProvProf, FORM_SECTIONS.AllProvTypes, FORM_SECTIONS.HospitalsOnly]);
        }



    }
    const onCollapseAll = (e) => {
        setActiveKeys(['PSO Details', 'Provider Details']);
        setPsoDetailsActive([]);
        setProviderDetailsActive([]);
    }

    const handleAClick = (e) => {
        e.stopPropagation()
    }

    function addAnswerValue (arr, accessKey, v) {
        var val = v.toString();

        if (arr.hasOwnProperty(accessKey)) {
            if (Array.isArray(arr[accessKey])) {
                arr[accessKey].push(val);
            }
            else {
                var old = arr[accessKey];
                arr[accessKey] = [old, val];
            }
        }
        else {
            arr[accessKey] = val;
        }
    }

    const updateFirstError = (v) => {
        //console.log(v);
        focusError = v;
        setFirstError(v);

        //console.log("setfirst");
        //console.log(focusError);
    }

    function addQuestionErrors (errors, object, dispatch, allowFocus) {
        var questions = object.questions;
        //console.log(object);

        var open = [];

        for (var subSection in questions) {
            var ques = questions[subSection];

            for (var q in ques) {
                //console.log(q);

                var qData = ques[q];
                if (errors.hasOwnProperty("answers[" + q + "]")) {
                    setFormSectionVisibility(
                        {
                            ...formSectionVisibility,
                            [FORM_SECTIONS_REV[subSection]]: true
                        }
                    );
                    //console.log(formSectionVisibility);
                    //console.log(errors["answers[" + q + "]"].errorMessages)

                    //console.log(ques);
                    //console.log(subSection);

                    if (open.includes(subSection) == false) {
                        open.push(subSection);
                    }

                    dispatch({
                        type: ACTIONS.UPDATE_QUESTION,
                        questionId: qData.id,
                        questionCode: qData.questionCode,
                        //value: qData.value,
                        subSection: subSection,
                        errors: errors["answers[" + q + "]"].errorMessages,
                        isInvalid: true,
                        pageType: pageType
                    });

                    if (allowFocus == true) {
                        //console.log(focusError);
                        if (focusError == null) {
                            //console.log("SET");
                            updateFirstError(q)
                            //console.log(qData.questionCode);
                            //console.log(firstError);
                        }
                    }
                }
                else {
                    dispatch({
                        type: ACTIONS.UPDATE_QUESTION,
                        questionId: qData.id,
                        questionCode: qData.questionCode,
                        //value: qData.value,
                        subSection: subSection,
                        errors: [],
                        isInvalid: false,
                        pageType: pageType
                    });
                }
            }
        }


        if (object.sectionName == "ProviderDetails") {
            //console.log("providerdetails");
            //console.log((providerDetailsActive));
            setProviderDetailsActive([...providerDetailsActive, ...open]);
        }
        else if (object.sectionName == "PSOProfile") {
            //console.log("psoprofile")
            //console.log((psoDetailsActive));
            setPsoDetailsActive([...psoDetailsActive, ...open]);
        }
    }

    const getFormQuestionData = (all) => {
        var arr = {};
        for (var i = 0; i < all.length; i++) {
            var index = all[i];
            for (var key in index) {
                if (index.hasOwnProperty(key)) {
                    var ans = index[key].answers;
                    if (ans.length > 0) {
                        if (index[key].typeCode === "RADIO") {
                            for (var y = 0; y < ans.length; y++) {
                                if (ans[y].checked == true) {
                                    addAnswerValue(arr, index[key].questionCode.toLowerCase(), ans[y].answerCode);
                                }
                            }
                        }
                        else if (index[key].typeCode === "NUMBER") {
                            if (ans[x].value != null && ans[x].value != "") {
                                addAnswerValue(arr, index[key].questionCode.toLowerCase(), ans[x].answerCode);
                                addAnswerValue(arr, index[key].questionCode.toLowerCase() + "number", ans[x].value);
                            }
                        }
                        else if (index[key].typeCode === "CHECKBOX_NUMBER" || index[key].typeCode === "CHECKBOX") {
                            //console.log("CHECKBOX");
                            for (var y = 0; y < ans.length; y++) {
                                if (ans[y].answerCode === "C012" || ans[y].answerCode === "C199") {
                                    if (index[key].typeCode === "CHECKBOX_NUMBER") {
                                        var isAdded = false;
                                        if (ans[y].value.text != null && ans[y].value.text != "") {
                                            isAdded = true;
                                            addAnswerValue(arr, index[key].questionCode.toLowerCase() + "txt", ans[y].value.text);
                                        }
                                        if (ans[y].value.number != null && ans[y].value.number != "") {
                                            isAdded = true;
                                            addAnswerValue(arr, index[key].questionCode.toLowerCase() + ans[y].answerCode + "number", ans[y].value.number);
                                        }
                                        if (isAdded == true || ans[y].checked == true) {
                                            addAnswerValue(arr, index[key].questionCode.toLowerCase(), ans[y].answerCode);
                                        }
                                    }
                                    else {
                                        if (ans[y].value != null && ans[y].value != "") {
                                            addAnswerValue(arr, index[key].questionCode.toLowerCase(), ans[y].answerCode);
                                            addAnswerValue(arr, index[key].questionCode.toLowerCase() + "txt", ans[y].value);
                                        }
                                        else {
                                            if (ans[y].checked == true) {
                                                addAnswerValue(arr, index[key].questionCode.toLowerCase(), ans[y].answerCode);
                                            }

                                        }
                                    }
                                }
                                else {
                                    //console.log(ans[y]);
                                    //console.log(ans[y].value);
                                    if (index[key].typeCode === "CHECKBOX_NUMBER") {
                                        var isAdded = false;
                                        if (ans[y].value != null && ans[y].value != "") {
                                            isAdded = true;
                                            //addAnswerValue(arr,index[key].questionCode.toLowerCase(),ans[y].answerCode);
                                            addAnswerValue(arr, index[key].questionCode.toLowerCase() + ans[y].answerCode + "number", ans[y].value);
                                        }
                                        if (isAdded == true || ans[y].checked == true) {
                                            addAnswerValue(arr, index[key].questionCode.toLowerCase(), ans[y].answerCode);
                                        }

                                    }
                                    else {
                                        if (ans[y].checked == true) {
                                            addAnswerValue(arr, index[key].questionCode.toLowerCase(), ans[y].answerCode);
                                        }
                                    }

                                    /*else{
                                        if(ans[y].checked == true){
                                            addAnswerValue(arr,index[key].questionCode.toLowerCase(),ans[y].answerCode);
                                        }
                                        
                                    }
                                




                                if(index[key].typeCode==="CHECKBOX_NUMBER"){
                                    
                                    if(ans[y].value != null && ans[y].value != ""){
                                        isAdded=true;
                                        addAnswerValue(arr,index[key].questionCode.toLowerCase()+ans[y].answerCode+"number",ans[y].value);
                                    }
                                    if(ans[y].checked == true){
                                        addAnswerValue(arr,index[key].questionCode.toLowerCase(),ans[y].answerCode);    
                                    }
                                }*/

                                }
                            }
                        }
                        else {
                            for (var x = 0; x < ans.length; x++) {
                                if (ans[x].answerCode === "C012" || ans[x].answerCode === "C199") {
                                    if (ans[x].value != null && ans[x].value != "") {
                                        addAnswerValue(arr, index[key].questionCode.toLowerCase(), ans[x].answerCode);
                                        addAnswerValue(arr, index[key].questionCode.toLowerCase() + "txt", ans[x].value);
                                    }
                                    else {
                                        addAnswerValue(arr, index[key].questionCode.toLowerCase(), ans[x].answerCode);
                                    }
                                }
                                else {
                                    if (ans[x].value != null && ans[x].value != "") {
                                        addAnswerValue(arr, index[key].questionCode.toLowerCase(), ans[x].answerCode);
                                    }
                                }
                            }
                        }
                    }
                    else {
                        if (index[key].value != null && index[key].value != "") {
                            if ((index[key].questionCode.toLowerCase() == "pso31" || index[key].questionCode.toLowerCase() == "pso30") && index[key].value == -1) {
                                addAnswerValue(arr, index[key].questionCode.toLowerCase() + "providechk", index[key].value);
                            }
                            else {
                                addAnswerValue(arr, index[key].questionCode.toLowerCase(), index[key].value);
                            }
                        }
                    }
                }
            }
        }
        return arr;
    }

    const handleSubmit = async (e) => {

        setIsLoadingSubmit(true);

        submitBtnRef.current?.blur();
        //console.log("submitPSOProfile");
        var url = '/api/profile/submitPsoProfile';

        var reportYear = profileReportYear;
        var organizationId = orgPsoId;

        var saveAction = null;
        var submitAction = 'SUBMIT';

        var all = [
            psoProfileSection.questions.psoCharacteristics,
            psoProfileSection.questions.participatingProviders,
            psoProfileSection.questions.patientSafetyWorkProduct,
            providerDetailsSection.questions.providerProfile,
            providerDetailsSection.questions.allProviderTypes,
            providerDetailsSection.questions.hosiptalsOnly
        ]

        var arr = getFormQuestionData(all);

        var values = {
            psoProfileBean: {
                id: profileId,
                saveAction: saveAction,
                submitAction: submitAction,
                confirmSubmit: confirmSubmit.checkBoxes[0].isChecked,
                answers: arr,
                reportYear: reportYear.value,
                organizationId: orgId,
                profileStatusId: 1
            },
            carryOverProfile: pageType == "CARRY" && profileId == null ? true : false
        }

        const loginState = store.getState().loginInfo;
        const res = http.post(url, values, {
            timeout: 65000, // Set a timeout of 5 seconds,
            headers: {
                "Authorization": "Bearer " + loginState.token
            }
        }).then((response) => {
            //console.log(response);
            if (response != null) {
                //console.log(submitBtnRef);
                //submitBtnRef.current.blur();
                if (response.hasOwnProperty("data") && response.data.hasOwnProperty("profileId")) {
                    setProfileId(response.data.profileId);
                }

                //console.log(response);
                var statusCode = response.status;
                if (statusCode != 1 || response.globalErrorMessageList.length > 0) {
                    //console.log(response.globalErrorMessageList);
                    var d = response.fieldErrors;
                    //console.log(d);
                    if (d.hasOwnProperty("confirmSubmit")) {
                        var errorM = d["confirmSubmit"].errorMessages;
                        confirmSubmitInputDispatch({
                            type: 'check-set-errors',
                            errors: errorM
                        });
                    }

                    setGlobalErrorStatus({
                        dispatch: dispatch,
                        popupData: {
                            visible: true,
                            title: ERROR_MESSAGES.GENERAL_ERROR.title,
                            msg: response.globalErrorMessageList,
                            showContactHelp: false
                        },
                        redirect: {
                            redirect: false,
                            redirectFirst: false,
                            path: "",
                            data: {}
                        }
                    });

                    addQuestionErrors(d, psoProfileSection, psoProfileSectionInputDispatch, true);
                    addQuestionErrors(d, providerDetailsSection, providerDetailsSectionInputDispatch, true);
                }
                else {
                    setGlobalSuccessStatus({
                        dispatch: dispatch,
                        popupData: {
                            visible: true,
                            title: "Success!",
                            msg: response.message,
                            showContactHelp: false
                        },
                        redirect: {
                            redirect: true,
                            redirectFirst: true,
                            path: "/manage/profile"

                        }
                    });
                }

            }
            else {
                //console.log("ELSE");
                setGlobalErrorStatus({
                    dispatch: dispatch,
                    popupData: {
                        visible: true,
                        title: ERROR_MESSAGES.GENERAL_ERROR.title,
                        msg: ERROR_MESSAGES.GENERAL_ERROR.message,
                        showContactHelp: true
                    },
                    redirect: {
                        redirect: false,
                        redirectFirst: false,
                        path: "",
                        data: {}
                    }
                });
            }
            setIsLoadingSubmit(false);
        }).catch(function (error) {
            //console.log(error);
            setGlobalErrorStatus({
                dispatch: dispatch,
                popupData: {
                    visible: true,
                    title: ERROR_MESSAGES.GENERAL_ERROR.title,
                    msg: ERROR_MESSAGES.GENERAL_ERROR.message,
                    showContactHelp: true
                },
                redirect: {
                    redirect: false,
                    redirectFirst: false,
                    path: "",
                    data: {}
                },
                error: error
            });
            setIsLoadingSubmit(false);
        });
        return res;
    };

    const handleSave = async () => {
        setIsLoadingSubmit(true);
        saveBtnRef.current?.blur();

        var url = '/api/profile/savePsoProfile';

        var reportYear = profileReportYear;
        var saveAction = 'SAVE';
        var submitAction = null;

        var all = [
            psoProfileSection.questions.psoCharacteristics,
            psoProfileSection.questions.participatingProviders,
            psoProfileSection.questions.patientSafetyWorkProduct,
            providerDetailsSection.questions.providerProfile,
            providerDetailsSection.questions.allProviderTypes,
            providerDetailsSection.questions.hosiptalsOnly
        ]

        var arr = getFormQuestionData(all);

        var values = {
            psoProfileBean: {
                id: profileId,
                saveAction: saveAction,
                submitAction: submitAction,
                answers: arr,
                reportYear: reportYear.value,
                organizationId: orgId,
                profileStatusId: 1
            },
            carryOverProfile: pageType == "CARRY" && profileId == null ? true : false
        }

        const loginState = store.getState().loginInfo;
        const res = http.post(url, values, {
            headers: {
                "Authorization": "Bearer " + loginState.token
            }
        }).then((response) => {
            if (response != null) {
                //console.log(response);
                //saveBtnRef.current?.blur();
                var statusCode = response.status;
                if (statusCode != 1 || response.globalErrorMessageList.length > 0) {
                    //console.log(response.globalErrorMessageList);
                    var d = response.fieldErrors;
                    var x = 0;
                    var isFirst = false;

                    if (d.hasOwnProperty("confirmSubmit")) {
                        var errorM = d["confirmSubmit"].errorMessages;
                        confirmSubmitInputDispatch({
                            type: 'check-set-errors',
                            errors: errorM
                        });
                    }

                    setGlobalErrorStatus({
                        dispatch: dispatch,
                        popupData: {
                            visible: true,
                            title: ERROR_MESSAGES.GENERAL_ERROR.title,
                            msg: response.globalErrorMessageList,
                            showContactHelp: false
                        },
                        redirect: {
                            redirect: false,
                            redirectFirst: false,
                            path: "",
                            data: {}
                        }
                    });

                    addQuestionErrors(d, psoProfileSection, psoProfileSectionInputDispatch, true);
                    addQuestionErrors(d, providerDetailsSection, providerDetailsSectionInputDispatch, true);
                }
                else {

                    setGlobalSuccessStatus({
                        dispatch: dispatch,
                        popupData: {
                            visible: true,
                            title: "Success!",
                            msg: response.message,
                            showContactHelp: false
                        },
                        redirect: {
                            redirect: true,
                            redirectFirst: true,
                            path: "/manage/profile"
                        }
                    });
                }
            }
            else {
                setGlobalErrorStatus({
                    dispatch: dispatch,
                    popupData: {
                        visible: true,
                        title: ERROR_MESSAGES.GENERAL_ERROR.title,
                        msg: ERROR_MESSAGES.GENERAL_ERROR.message,
                        showContactHelp: true
                    },
                    redirect: {
                        redirect: false,
                        redirectFirst: false,
                        path: "",
                        data: {}
                    }
                });
            }
            setIsLoadingSubmit(false);
        }).catch(function (error) {
            setGlobalErrorStatus({
                dispatch: dispatch,
                popupData: {
                    visible: true,
                    title: ERROR_MESSAGES.GENERAL_ERROR.title,
                    msg: ERROR_MESSAGES.GENERAL_ERROR.message,
                    showContactHelp: true
                },
                redirect: {
                    redirect: false,
                    redirectFirst: false,
                    path: "",
                    data: {}
                },
                error: error
            });
            setIsLoadingSubmit(false);
        });

        return res;


    };
    const handleCancel = async () => {
        if (backRedirect.path == null) {
            setBackRedirect("/manage/profile");
        }
        navigate(
            backRedirect.path,
            { state: backRedirect.state }
        );
    };

    return (
        <Row >
            {

                <Row >
                    <Col xl={11} lg={11} md={11} sm={12}>
                        <Card className="p-3 p-sm-4" >
                            <Card.Body className="text-start">

                                <Row>
                                    <h1 id="mainContent" className="header1 text-start mb-3 blue bold">{pageTitle}</h1>

                                </Row>
                                <Row>

                                    <Form className="create-pso-profile-form">

                                        <h2>Account Details</h2>

                                        <FormInputDisplay fieldData={orgPsoId} inputDispatch={orgPsoIdInputDispatch} orgType={null} isHorizontal={true} hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }}></FormInputDisplay>

                                        {pageType == "VIEW"
                                            ? <FormInputDisplay fieldData={orgPsoStatus} inputDispatch={orgPsoStatusInputDispatch} orgType={null} isHorizontal={true} hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }}></FormInputDisplay>
                                            : null
                                        }
                                        <FormInputDisplay fieldData={orgListingDate} inputDispatch={orgListingDateInputDispatch} orgType={null} isHorizontal={true} hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }}></FormInputDisplay>

                                        <FormInputDisplay fieldData={profileReportYear} inputDispatch={profileReportYearInputDispatch} orgType={null} isHorizontal={true} hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }}></FormInputDisplay>

                                        {/*
                                            PSO Id
                                            PSO Listing Date
                                            Reporting Year
                                       */}

                                        {pageType != "VIEW"
                                            ?
                                            <>
                                                <h2>PSO Profile Form</h2>
                                                <p>Enter the appropriate response(s) for each question. You may save your form prior to completion and return to it later for further editing. When you are ready to submit your form, you must select the checkbox at the end, acknowledging your review of all answers provided.</p>
                                                <p>Only complete form submissions with valid answers will be accepted by the PSOPPC. To submit your form, please select the 'Submit' button at the bottom of this form.</p>
                                            </>
                                            :
                                            null
                                        }

                                        <Stack className="d-flex justify-content-end pt-3 collapseExpand mb-3 flex-wrap" direction="horizontal" gap={2}>
                                            {/* Expand Button */}

                                            <IconTextButton
                                                className={"me-2"}
                                                onClick={onExpandAll}
                                                variant="outline"
                                                icon={() => <UnfoldMoreOutlined ></UnfoldMoreOutlined>}
                                                content={"Expand All"}
                                            />

                                            {/* Collapse Button */}
                                            <IconTextButton
                                                className={"me-2 "}
                                                onClick={onCollapseAll}
                                                variant="normal"
                                                icon={() => <UnfoldLessOutlined></UnfoldLessOutlined>}
                                                content={"Collapse All"}
                                            />
                                        </Stack>


                                        {isLoading == true ?
                                            null
                                            : <Accordion defaultActiveKey={['PSO Details', 'Provider Details']} activeKey={activeKeys} alwaysOpen>
                                                <Accordion.Item onClick={(e) => onAccordionToggle(e, "PSO Details", "main")} eventKey="PSO Details">
                                                    <AccordianHeaderLevel1
                                                        //className={"me-2"} 
                                                        label="PSO Details"
                                                    />
                                                    <Accordion.Body onClick={handleAClick}>
                                                        <Accordion defaultActiveKey={[]} activeKey={psoDetailsActive} alwaysOpen>

                                                            {
                                                                formSectionVisibility.PSOChars == true
                                                                    ? <Accordion.Item className="mb-2" onClick={(e) => onAccordionToggle(e, FORM_SECTIONS.PSOChars, "psoDetails")} eventKey={FORM_SECTIONS.PSOChars}>
                                                                        <AccordianHeaderLevel2
                                                                            className={isSectionVisible(psoProfileSection, FORM_SECTIONS.PSOChars) == false ? "disabled" : ""}
                                                                            label={profileReportYear.value < 2020 ? "PSO Characteristics (Questions 1-7)" : (profileReportYear.value>=2025 ? "PSO Characteristics (Questions 1-6)":"PSO Characteristics (Questions 1-5)")}
                                                                        />
                                                                        <Accordion.Body onClick={handleAClick} className={isSectionVisible(psoProfileSection, FORM_SECTIONS.PSOChars) == false ? "disabled" : ""}>

                                                                            {
                                                                                isLoading != true && isValuesLoading != true ?
                                                                                    <>
                                                                                        <PageInfo classes="mt-1 mb-4" type="info" message={
                                                                                            FORM_SECTION_NOTES.PSOChars

                                                                                        }
                                                                                        ></PageInfo>
                                                                                        {

                                                                                            Object.keys(psoProfileSection.questions[FORM_SECTIONS.PSOChars]).map(key => {
                                                                                                return (
                                                                                                    <Form.Group as={Row}>
                                                                                                        <PSOFormFields
                                                                                                            section={psoProfileSection}
                                                                                                            subSection={FORM_SECTIONS.PSOChars}
                                                                                                            dispatch={psoProfileSectionInputDispatch}
                                                                                                            question={psoProfileSection.questions[FORM_SECTIONS.PSOChars][key]}
                                                                                                            setShowProvSection={setShowProvSection}
                                                                                                            setFormSectionVisibility={setFormSectionVisibility}
                                                                                                            formSectionVisibility={formSectionVisibility}

                                                                                                            setInputRefs={addToRefs}
                                                                                                            isLoading={isLoading}
                                                                                                            isValuesLoading={isValuesLoading}
                                                                                                            pageType={pageType}
                                                                                                            reportYear={profileReportYear}

                                                                                                            notes={FORM_SECTION_NOTES}
                                                                                                            userAnsState={userAnsState}
                                                                                                        >
                                                                                                        </PSOFormFields>
                                                                                                    </Form.Group>)

                                                                                            })
                                                                                        }
                                                                                    </>
                                                                                    : null

                                                                            }

                                                                        </Accordion.Body>
                                                                    </Accordion.Item>
                                                                    : null
                                                            }
                                                            {
                                                                formSectionVisibility.PartiProv == true
                                                                    ? <Accordion.Item className="mb-2" onClick={(e) => onAccordionToggle(e, FORM_SECTIONS.PartiProv, "psoDetails")} eventKey={FORM_SECTIONS.PartiProv}>
                                                                        <AccordianHeaderLevel2
                                                                            className={isSectionVisible(psoProfileSection, FORM_SECTIONS.PartiProv) == false ? "disabled" : ""}
                                                                            label={profileReportYear.value > 2019 ? (profileReportYear.value>=2025 ? "Participating Providers (Question 7)":"Participating Providers (Question 6)") : "Provider Contracts (Questions 8-10)"}
                                                                        />
                                                                        <Accordion.Body onClick={handleAClick} className={isSectionVisible(psoProfileSection, FORM_SECTIONS.PartiProv) == false ? "disabled" : ""}>

                                                                            {
                                                                                isLoading != true && isValuesLoading != true ?
                                                                                    <>
                                                                                        <PageInfo classes="mt-1 mb-4" type="info" message={

                                                                                            FORM_SECTION_NOTES.PartiProv
                                                                                        }
                                                                                        ></PageInfo>
                                                                                        {

                                                                                            Object.keys(psoProfileSection.questions[FORM_SECTIONS.PartiProv]).map(key => {
                                                                                                return (
                                                                                                    <Form.Group as={Row} >
                                                                                                        <PSOFormFields
                                                                                                            section={psoProfileSection}
                                                                                                            subSection={FORM_SECTIONS.PartiProv}
                                                                                                            dispatch={psoProfileSectionInputDispatch}
                                                                                                            question={psoProfileSection.questions[FORM_SECTIONS.PartiProv][key]}
                                                                                                            setShowProvSection={setShowProvSection}
                                                                                                            setFormSectionVisibility={setFormSectionVisibility}
                                                                                                            formSectionVisibility={formSectionVisibility}

                                                                                                            setInputRefs={addToRefs}
                                                                                                            isLoading={isLoading}
                                                                                                            isValuesLoading={isValuesLoading}
                                                                                                            pageType={pageType}
                                                                                                            reportYear={profileReportYear}
                                                                                                            userAnsState={userAnsState}
                                                                                                        >
                                                                                                        </PSOFormFields>
                                                                                                    </Form.Group>)

                                                                                            })
                                                                                        }
                                                                                    </>
                                                                                    : null

                                                                            }
                                                                        </Accordion.Body>
                                                                    </Accordion.Item>
                                                                    : null
                                                            }
                                                            {
                                                                formSectionVisibility.PtSafetyWorkProd == true
                                                                    ?
                                                                    <Accordion.Item className="mb-2" onClick={(e) => onAccordionToggle(e, FORM_SECTIONS.PtSafetyWorkProd, "psoDetails")} eventKey={FORM_SECTIONS.PtSafetyWorkProd}>
                                                                        <AccordianHeaderLevel2
                                                                            className={isSectionVisible(psoProfileSection, FORM_SECTIONS.PtSafetyWorkProd) == false ? "disabled" : ""}
                                                                            label={profileReportYear.value > 2019 ? (profileReportYear.value>=2025 ? "Patient Safety Work Product (Questions 8-9)" : "Patient Safety Work Product (Questions 7-8)") : "Patient Safety Work Product (Questions 11-16)"}
                                                                        />
                                                                        <Accordion.Body onClick={handleAClick} className={isSectionVisible(psoProfileSection, FORM_SECTIONS.PtSafetyWorkProd) == false ? "disabled" : ""}>

                                                                            {
                                                                                isLoading != true && isValuesLoading != true ?
                                                                                    <>
                                                                                        {


                                                                                            Object.keys(psoProfileSection.questions[FORM_SECTIONS.PtSafetyWorkProd]).map(key => {
                                                                                                return (
                                                                                                    <Form.Group as={Row} >
                                                                                                        <PSOFormFields
                                                                                                            section={psoProfileSection}
                                                                                                            subSection={FORM_SECTIONS.PtSafetyWorkProd}
                                                                                                            dispatch={psoProfileSectionInputDispatch}
                                                                                                            question={psoProfileSection.questions[FORM_SECTIONS.PtSafetyWorkProd][key]}
                                                                                                            setShowProvSection={setShowProvSection}
                                                                                                            setFormSectionVisibility={setFormSectionVisibility}
                                                                                                            formSectionVisibility={formSectionVisibility}

                                                                                                            setInputRefs={addToRefs}
                                                                                                            isLoading={isLoading}
                                                                                                            isValuesLoading={isValuesLoading}
                                                                                                            pageType={pageType}
                                                                                                            reportYear={profileReportYear}
                                                                                                            userAnsState={userAnsState}
                                                                                                        >
                                                                                                        </PSOFormFields>
                                                                                                    </Form.Group>)

                                                                                            })
                                                                                        }
                                                                                    </>
                                                                                    : null

                                                                            }
                                                                        </Accordion.Body>
                                                                    </Accordion.Item>
                                                                    : null
                                                            }
                                                        </Accordion>
                                                    </Accordion.Body>
                                                </Accordion.Item>

                                                {showProvSection == true && profileReportYear.value > 2019 ?
                                                    <Accordion.Item onClick={(e) => onAccordionToggle(e, "Provider Details", "main")} eventKey="Provider Details">
                                                        <AccordianHeaderLevel1

                                                            label={"Provider Details"}
                                                        />
                                                        <Accordion.Body onClick={handleAClick}>
                                                            <Accordion activeKey={providerDetailsActive} alwaysOpen>
                                                                {
                                                                    formSectionVisibility.ProvProf == true
                                                                        ?
                                                                        <Accordion.Item className="mb-2" onClick={(e) => { onAccordionToggle(e, FORM_SECTIONS.ProvProf, "providerDetails") }} eventKey={FORM_SECTIONS.ProvProf}>
                                                                            <AccordianHeaderLevel2
                                                                                className={isSectionVisible(providerDetailsSection, FORM_SECTIONS.ProvProf) == false ? "disabled" : ""}
                                                                                label="Provider Profile (Question 1)"
                                                                            />

                                                                            <Accordion.Body onClick={handleAClick} className={isSectionVisible(providerDetailsSection, FORM_SECTIONS.ProvProf) == false ? "disabled" : ""}>
                                                                                {
                                                                                    isLoading != true && isValuesLoading != true ?
                                                                                        <>
                                                                                            <PageInfo classes="mt-1 mb-4" type="info" message={

                                                                                                FORM_SECTION_NOTES.ProvProf
                                                                                            }
                                                                                            ></PageInfo>
                                                                                            {
                                                                                                Object.keys(providerDetailsSection.questions[FORM_SECTIONS.ProvProf]).map(key => {
                                                                                                    return (
                                                                                                        <Form.Group as={Row} >
                                                                                                            <PSOFormFields
                                                                                                                section={providerDetailsSection}
                                                                                                                subSection={FORM_SECTIONS.ProvProf}
                                                                                                                dispatch={providerDetailsSectionInputDispatch}
                                                                                                                question={providerDetailsSection.questions[FORM_SECTIONS.ProvProf][key]}
                                                                                                                setShowProvSection={setShowProvSection}
                                                                                                                setFormSectionVisibility={setFormSectionVisibility}
                                                                                                                formSectionVisibility={formSectionVisibility}

                                                                                                                setInputRefs={addToRefs}
                                                                                                                isLoading={isLoading}
                                                                                                                isValuesLoading={isValuesLoading}
                                                                                                                pageType={pageType}
                                                                                                                reportYear={profileReportYear}
                                                                                                                userAnsState={userAnsState}
                                                                                                            >
                                                                                                            </PSOFormFields>
                                                                                                        </Form.Group>)
                                                                                                })
                                                                                            }
                                                                                        </>
                                                                                        : null

                                                                                }
                                                                            </Accordion.Body>

                                                                        </Accordion.Item>
                                                                        : null
                                                                }
                                                                {
                                                                    formSectionVisibility.AllProvTypes == true
                                                                        ?
                                                                        <Accordion.Item className="mb-2" onClick={(e) => onAccordionToggle(e, FORM_SECTIONS.AllProvTypes, "providerDetails")} eventKey={FORM_SECTIONS.AllProvTypes}>
                                                                            <AccordianHeaderLevel2
                                                                                className={isSectionVisible(providerDetailsSection, FORM_SECTIONS.AllProvTypes) == false ? "disabled" : ""}
                                                                                label="Provider Profile - All Provider Types (Question 2)"
                                                                            />

                                                                            <Accordion.Body onClick={handleAClick} className={isSectionVisible(providerDetailsSection, FORM_SECTIONS.AllProvTypes) == false ? "disabled" : ""}>
                                                                                {
                                                                                    isLoading != true && isValuesLoading != true ?
                                                                                        <>
                                                                                            {

                                                                                                Object.keys(providerDetailsSection.questions[FORM_SECTIONS.AllProvTypes]).map(key => {
                                                                                                    return (
                                                                                                        <Form.Group as={Row} >
                                                                                                            <PSOFormFields
                                                                                                                section={providerDetailsSection}
                                                                                                                subSection={FORM_SECTIONS.AllProvTypes}
                                                                                                                dispatch={providerDetailsSectionInputDispatch}
                                                                                                                question={providerDetailsSection.questions[FORM_SECTIONS.AllProvTypes][key]}
                                                                                                                setShowProvSection={setShowProvSection}
                                                                                                                setFormSectionVisibility={setFormSectionVisibility}
                                                                                                                formSectionVisibility={formSectionVisibility}

                                                                                                                setInputRefs={addToRefs}
                                                                                                                isLoading={isLoading}
                                                                                                                isValuesLoading={isValuesLoading}
                                                                                                                pageType={pageType}
                                                                                                                reportYear={profileReportYear}
                                                                                                                userAnsState={userAnsState}
                                                                                                            >
                                                                                                            </PSOFormFields>
                                                                                                        </Form.Group>)

                                                                                                })
                                                                                            }
                                                                                        </>
                                                                                        : null

                                                                                }
                                                                            </Accordion.Body>

                                                                        </Accordion.Item>

                                                                        : null
                                                                }
                                                                {
                                                                    formSectionVisibility.HospitalsOnly == true
                                                                        ?
                                                                        <Accordion.Item className="mb-2" onClick={(e) => onAccordionToggle(e, FORM_SECTIONS.HospitalsOnly, "providerDetails")} eventKey={FORM_SECTIONS.HospitalsOnly}>
                                                                            <AccordianHeaderLevel2
                                                                                className={isSectionVisible(providerDetailsSection, FORM_SECTIONS.HospitalsOnly) == false ? "disabled" : ""}
                                                                                label="Provider Profile - Hospitals Only (Questions 3-5)"
                                                                            />
                                                                            <Accordion.Body onClick={handleAClick} className={isSectionVisible(providerDetailsSection, FORM_SECTIONS.HospitalsOnly) == false ? "disabled" : ""}>
                                                                                {
                                                                                    isLoading != true && isValuesLoading != true ?
                                                                                        <>
                                                                                            <PageInfo classes="mt-1 mb-4" type="info" message={

                                                                                                FORM_SECTION_NOTES.HospitalsOnly
                                                                                            }
                                                                                            ></PageInfo>

                                                                                            {

                                                                                                Object.keys(providerDetailsSection.questions[FORM_SECTIONS.HospitalsOnly]).map(key => {
                                                                                                    return (
                                                                                                        <Form.Group as={Row} >
                                                                                                            <PSOFormFields
                                                                                                                section={providerDetailsSection}
                                                                                                                subSection={FORM_SECTIONS.HospitalsOnly}
                                                                                                                dispatch={providerDetailsSectionInputDispatch}
                                                                                                                question={providerDetailsSection.questions[FORM_SECTIONS.HospitalsOnly][key]}
                                                                                                                setShowProvSection={setShowProvSection}
                                                                                                                setFormSectionVisibility={setFormSectionVisibility}
                                                                                                                formSectionVisibility={formSectionVisibility}
                                                                                                                setInputRefs={addToRefs}
                                                                                                                isLoading={isLoading}
                                                                                                                isValuesLoading={isValuesLoading}
                                                                                                                pageType={pageType}
                                                                                                                reportYear={profileReportYear}
                                                                                                                userAnsState={userAnsState}
                                                                                                            >
                                                                                                            </PSOFormFields>
                                                                                                        </Form.Group>
                                                                                                    )

                                                                                                })
                                                                                            }
                                                                                        </>
                                                                                        : null

                                                                                }
                                                                            </Accordion.Body>
                                                                        </Accordion.Item>
                                                                        : null
                                                                }
                                                            </Accordion>
                                                        </Accordion.Body>
                                                    </Accordion.Item>
                                                    : null
                                                }

                                            </Accordion>
                                        }

                                        {
                                            pageType != "VIEW"
                                                ?
                                                <>
                                                    <Stack className="pt-3" direction="horizontal" gap={3}>
                                                        {/* Submit Button */}
                                                        {(pageType=="EDIT" && psoppcAdmin!=true) || pageType!="EDIT" ?
                                                            <TextButton
                                                                variant="normal"
                                                                onClick={handleSave}
                                                                content={"Save"}
                                                                ref={saveBtnRef}
                                                                disabled={isLoading != true && isLoadingSubmit != true ? false : true}
                                                            >
                                                            </TextButton>
                                                        :null}

                                                        {/* Cancel Button */}
                                                        <TextButton
                                                            variant="outline"
                                                            onClick={handleCancel}
                                                            content={"Cancel"}
                                                            disabled={isLoading != true && isLoadingSubmit != true ? false : true}
                                                        >
                                                        </TextButton>
                                                    </Stack>

                                                    {(pageType=="EDIT" && psoppcAdmin!=true) || pageType!="EDIT" ?
                                                        <>
                                                            <h2>Review and Submit</h2>
                                                            <FormInputDisplay fieldData={confirmSubmit} inputDispatch={confirmSubmitInputDispatch} orgType={null} isHorizontal={false} hideLabel={false} horizontalForm={{ is: false, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 10 } }}></FormInputDisplay>

                                                            {/* Submit Button */}
                                                            <TextButton
                                                                variant="normal"
                                                                onClick={handleSubmit}
                                                                content={"Submit"}
                                                                ref={submitBtnRef}
                                                                disabled={(confirmSubmit.checkBoxes[0]).isChecked == true && isLoading != true && isLoadingSubmit != true ? false : true}
                                                            >
                                                            </TextButton>
                                                        </>
                                                        : null
                                                    }

                                                    <p className="mt-5">
                                                        <b>Form Approved: OMB NO.: 0935-0143 Exp. Date: 07/31/2028</b>
                                                    </p>
                                                    <p>
                                                        <b>Burden Statement</b>
                                                    </p>
                                                    <p className="small-desc">
                                                        This survey is authorized under 42 U.S.C. 299a. This information collection is voluntary and the confidentiality of your responses to this survey is protected by Sections 944(c) and 308(d) of the Public Health Service Act [42 U.S.C. 299c-3(c) and 42 U.S.C. 242m(d)]. Information that could identify you will not be disclosed unless you have consented to that disclosure. Public reporting burden for this collection of information is estimated to average x minutes per response, the estimated time required to complete the survey. An agency may not conduct or sponsor, and a person is not required to respond to, a collection of information unless it displays a currently valid OMB control number. The data provided will help AHRQ's mission to produce evidence to make health care safer, higher quality, more accessible, equitable, and affordable. Send comments regarding this burden estimate or any other aspect of this collection of information, including suggestions for reducing this burden, to: AHRQ Reports Clearance Officer Attention: PRA, Paperwork Reduction Project (OMB control number 0935-0143) AHRQ, 5600 Fishers Lane, Room #07W42, Rockville, MD 20857, or by email to <a href="mailto:REPORTSCLEARANCEOFFICER@ahrq.hhs.gov">REPORTSCLEARANCEOFFICER@ahrq.hhs.gov</a>.
                                                    </p>
                                                </>
                                                : <Stack className="pt-3" direction="horizontal" gap={3}>
                                                    {/* Cancel Button */}
                                                    <TextButton
                                                        variant="normal"
                                                        onClick={handleCancel}
                                                        content={"Back"}
                                                        disabled={isLoading != true && isLoadingSubmit != true ? false : true}
                                                    >
                                                    </TextButton>
                                                </Stack>
                                        }




                                    </Form>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            }

        </Row>
    );
}



export default ViewPSOProfile;